import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import {tokenRequest} from '../../api/tokenRequest';
import Logo from '../Logo';
import {InputField} from '../InputForms';
import {TextButton, TextButtonTypes} from '../Buttons';
import styles from './style.css';

const LoginForm = withRouter(inject('notificationsStore', 'localizationStore')(observer(class LoginForm extends Component {
    state = {
        identifier: '',
        password: ''
    };

    onCredentialsChanged = (event) => {
        let newState = this.state;
        newState[event.target.name] = event.target.value.trim();
        this.setState(newState)
    };

    validData = () => {
        return (this.state.identifier.trim() !== ''
            && this.state.password.trim() !== ''
        )
    };

    onLoginButtonClick = async () => {
        let response = await tokenRequest(this.state);
        switch (response.status){
            case 201: {
                 let data = await response.json();
                 try {
                     const split = data.accessToken._links[1].href.split('/')
                     localStorage.setItem('role', data.accessToken.userRole);
                     localStorage.setItem('secret', data.accessToken.secret);
                     localStorage.setItem('token', data.accessToken.token);
                     localStorage.setItem('_links', data.accessToken._links[1].href);
                     localStorage.setItem('userId', split.length > 0 ? split[split.length - 1] : null);
                     this.props.history.push('/agents')
                 } catch (e) {
                     console.error('Wrong response data format')
                 }
                return Promise.resolve()
            }
            case 403: {
                this.props.notificationsStore.pushNotification(this.props.localizationStore.locale.wrong_credentials)
                return Promise.reject()
            }

            default: {
                this.props.notificationsStore.pushNotification(this.props.localizationStore.locale.unknown_error)
                return Promise.reject()

            }
        }
    };

    render() {
        const locale = this.props.localizationStore.locale;
        return (
            <div className={styles.form}>
                <Logo />
                <InputField style={styles.inputField}
                            required
                            value={this.state.identifier}
                            name='identifier'
                            placeholder={locale.identifier}
                            onChange={this.onCredentialsChanged}
                />
                <InputField style={styles.inputField}
                            type='password'
                            required
                            value={this.state.password}
                            name='password'
                            placeholder={locale.password}
                            onChange={this.onCredentialsChanged}
                />
                <TextButton text={locale.login}
                            type={TextButtonTypes.primary}
                            onClick={this.onLoginButtonClick}
                            disabled={!this.validData()}
                />
            </div>
        );
    }
})));

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/LoginForm/index.js